import useCommon from '@utils/hooks/common';
import Poker from '@components/Poker';
import userIconFrame from '@public/images-mobile/game-room/my_icon.svg';
import Icon from '@ant-design/icons';
import {SUIT, UNIT_TYPE} from '@constant/game';
import styles from './styles';
import PlayerAvatar from '@components/PlayerAvatar';
import {PokerCard} from '@interface';
import classnames from 'classnames';

const cardToContainerRatio = 0.25;

const POT_TYPE = {
  MAIN_POT: 0,
  SIDE_POT_ONE: 1,
  SIDE_POT_TWO: 2,
  SIDE_POT_THREE: 3,
};

interface WinnerCardInterface {
  prize: string | number;
  playerName: string;
  combination: Array<PokerCard>;
  handCard?: Array<PokerCard>;
  // eslint-disable-next-line react/no-unused-prop-types
  containerWidthPx?: number;
  pot?: string;
  potId?: number;
  iconUrl?: string;
  showWinAmount: boolean;
}

const WinnerCard = (props: WinnerCardInterface) => {
  const {classes, t, language, game} = useCommon({
    withTranslation: ['history_drawer'],
    observers: ['game'],
    withStyles: {styles, hasProps: true, props},
  });

  const {unit} = game;

  const potName = {
    0: t('main_pot'),
    1: t('side_pot_one'),
    2: t('side_pot_two'),
    3: t('side_pot_three'),
  };

  const {
    potId,
    prize,
    playerName,
    combination,
    handCard,
    pot,
    containerWidthPx,
    iconUrl,
    showWinAmount,
  } = props;
  // const {prize, playerName, combination, pot, titleBackground} = props;
  const getTitleRowBackground = (potType: number): string => {
    if (potType === POT_TYPE.MAIN_POT)
      return 'linear-gradient(90deg, #FFC632 0%, #FFCD68 100%)';
    if (potType === POT_TYPE.SIDE_POT_ONE)
      return 'linear-gradient(90deg, #90C960 0%, #B3F26F 100%)';
    if (potType === POT_TYPE.SIDE_POT_TWO)
      return 'linear-gradient(90deg, #EA4F55 0%, #F56469 51.83%, #FF787C 100%)';
    if (potType === POT_TYPE.SIDE_POT_THREE) return 'purple';
    return 'linear-gradient(90deg, #3E87DD 0%, #4BBFF1 100%)';
  };

  const sortRankThenSuit = (cardOne, cardTwo) => {
    const suitOrder = ['DIAMOND', 'CLUB', 'HEART', 'SPADE'];
    const suitOneIndex = suitOrder.findIndex(index => index === cardOne.suit);
    const suitTwoIndex = suitOrder.findIndex(index => index === cardTwo.suit);

    if (cardOne.value < cardTwo.value) return 1;
    if (cardOne.value > cardTwo.value) return -1;
    if (suitOneIndex < suitTwoIndex) return 1;
    if (suitOneIndex > suitTwoIndex) return -1;
    return 0;
  };

  const sortedList = combination?.sort(sortRankThenSuit);

  const isMyCard = (checkingCard: PokerCard) => {
    if (handCard?.some(({rank, suit}) => rank === checkingCard.rank && suit === checkingCard.suit))
      return true;
    return false;
  };

  const renderPrizeAmount = (prizeLocal: number | string) => {
    let prize = prizeLocal;
    if (!Number.isNaN(prizeLocal)) {
      if (Number.isInteger(prizeLocal)) {
        prize = Number(prizeLocal);
      } else {
        prize = Number(prizeLocal).toFixed(2);
      }
    }

    if (unit === UNIT_TYPE.BIG_BLIND) return ` ${prize} BB`;
    return ` $ ${prize}`;
  };

  return (
    <div className={classes.container}>
      <section className={classes.titleField} style={{background: getTitleRowBackground(potId)}}>
        <div style={{marginTop: '0px'}}>
          <PlayerAvatar className={classes.playerIcon} iconWidthPx={30} icon={iconUrl} />
        </div>
        <div className={classes.title}>
          <div className={classes.nameSpan}>{playerName}</div>
          <div className={classes.potSpan}>{potName[potId] || pot}</div>
        </div>
      </section>
      <section className={classes.contentField}>
        <div
          className={classnames(classes.description, {
            [classes.hidden]: !showWinAmount,
          })}
        >
          {t('win')} {renderPrizeAmount(prize)}
        </div>
        <div className={classes.combination}>
          {sortedList?.map(({suit, rank}, index) => (
            <Poker
              // isInitiallyFlipped
              key={suit + rank + index}
              suit={suit as SUIT}
              rank={rank}
              cardHeight={(containerWidthPx || 100) * cardToContainerRatio}
              // className={classes.pokerCard}
              className={isMyCard({suit, rank}) ? classes.pokerCardHand : classes.pokerCard}
              isInitiallyFlipped
              // cardHeight={22}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default WinnerCard;
